import React, { useCallback, useEffect, useState } from 'react';
import { Slider } from 'antd-v5';
import { InputSliderProps } from './InputSlider.types';

export const InputSlider = ({ value, onChange, min, max }: InputSliderProps) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleChange = useCallback(
    (val: number | number[]) => {
      if (Array.isArray(val)) {
        return;
      }

      setInputValue(val);
      if (onChange) {
        onChange(val);
      }
    },
    [onChange],
  );

  return <Slider value={inputValue} onChange={handleChange} min={min} max={max} />;
};
